// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-games-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-games-section .slot-games-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.slot-games-section .slot-games-wrap .slot-games-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
  --grid-column-number: 4;
  --grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-number), 1fr);
  gap: var(--grid-gap);
  margin: 4rem 0;
}
.slot-games-section .slot-games-wrap .slot-games-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla {
  --embla-slide-number: calc(100% / 4);
  --embla-slide-gap: 2rem;
  width: 100%;
  filter: drop-shadow(0px 4px 4px var(--black-150));
  -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));
  margin-bottom: -4rem;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport {
  overflow: hidden;
  padding: 4rem 0;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container {
  display: flex;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container .embla__slide {
  min-width: 0;
  flex: 0 0 var(--embla-slide-number);
  padding: 0 1rem;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container .embla__slide .game-card {
  box-shadow: none !important;
}
.slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container .embla__slide .game-card:hover {
  box-shadow: 0px 0px 2rem var(--primaryMain-750) !important;
  filter: none !important;
  -webkit-filter: none !important;
}
@media screen and (max-width: 991.98px) {
  .slot-games-section {
    padding: 2.5rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .para-text {
    font-size: 1rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 4;
    --grid-gap: 1rem;
    margin: 2.5rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .btn-box {
    margin-top: 2.5rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla {
    --embla-slide-number: calc(100% / 4);
    --embla-slide-gap: 1rem;
    margin-bottom: -2.5rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport {
    padding: 2.5rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-games-section {
    padding: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .para-text {
    font-size: 0.875rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 2;
    --grid-gap: 1rem;
    margin: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .btn-box {
    margin-top: 1.25rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla {
    --embla-slide-number: calc(100% / 2);
    --embla-slide-gap: 1rem;
    margin-bottom: -2rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport {
    padding: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .slot-games-section {
    padding: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 2;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .embla {
    --embla-slide-number: calc(100% / 2);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SlotGamesSection/SlotGamesStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,6DAAA;EACA,oBAAA;EACA,cAAA;AADR;AAIM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAFR;AAKM;EACE,oCAAA;EACA,uBAAA;EACA,WAAA;EACA,iDAAA;EACA,yDAAA;EACA,oBAAA;AAHR;AAKQ;EACE,gBAAA;EACA,eAAA;AAHV;AAKU;EACE,aAAA;AAHZ;AAKY;EACE,YAAA;EACA,mCAAA;EACA,eAAA;AAHd;AAKc;EACE,2BAAA;AAHhB;AAKgB;EACE,0DAAA;EACA,uBAAA;EACA,+BAAA;AAHlB;AAaE;EApEF;IAqEI,iBAAA;EAVF;EAcM;IACE,eAAA;EAZR;EAeM;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EAbR;EAgBM;IACE,kBAAA;EAdR;EAiBM;IACE,oCAAA;IACA,uBAAA;IACA,sBAAA;EAfR;EAiBQ;IACE,iBAAA;EAfV;EAkBY;IACE,iBAAA;EAhBd;AACF;AAwBE;EA1GF;IA2GI,eAAA;EArBF;EAyBM;IACE,mBAAA;EAvBR;EA0BM;IACE,uBAAA;IACA,gBAAA;IACA,cAAA;EAxBR;EA2BM;IACE,mBAAA;EAzBR;EA4BM;IACE,oCAAA;IACA,uBAAA;IACA,oBAAA;EA1BR;EA4BQ;IACE,eAAA;EA1BV;EA6BY;IACE,kBAAA;EA3Bd;AACF;AAmCE;EAhJF;IAiJI,eAAA;EAhCF;EAoCM;IACE,uBAAA;EAlCR;EAqCM;IACE,oCAAA;EAnCR;AACF","sourcesContent":[".slot-games-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .slot-games-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .slot-games-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .games-grid-box {\n        --grid-column-number: 4;\n        --grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--grid-column-number), 1fr);\n        gap: var(--grid-gap);\n        margin: 4rem 0;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n\n      .embla {\n        --embla-slide-number: calc(100% / 4);\n        --embla-slide-gap: 2rem;\n        width: 100%;\n        filter: drop-shadow(0px 4px 4px var(--black-150));\n        -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));\n        margin-bottom: -4rem;\n        \n        .embla__viewport {\n          overflow: hidden;\n          padding: 4rem 0;\n\n          .embla__container {\n            display: flex;\n\n            .embla__slide {\n              min-width: 0;\n              flex: 0 0 var(--embla-slide-number);\n              padding: 0 1rem;\n\n              .game-card {\n                box-shadow: none !important;\n\n                &:hover {\n                  box-shadow: 0px 0px 2rem var(--primaryMain-750) !important;\n                  filter: none !important;\n                  -webkit-filter: none !important;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .slot-games-wrap {\n      .slot-games-box {\n        .para-text {\n          font-size: 1rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 4;\n          --grid-gap: 1rem;\n          margin: 2.5rem 0;\n        }\n\n        .btn-box {\n          margin-top: 2.5rem;\n        }\n        \n        .embla {\n          --embla-slide-number: calc(100% / 4);\n          --embla-slide-gap: 1rem;\n          margin-bottom: -2.5rem;\n          \n          .embla__viewport {\n            padding: 2.5rem 0;\n\n            .embla__container {\n              .embla__slide {\n                padding: 0 0.5rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .slot-games-wrap {\n      .slot-games-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 2;\n          --grid-gap: 1rem;\n          margin: 2rem 0;\n        }\n\n        .btn-box {\n          margin-top: 1.25rem;\n        }\n    \n        .embla {\n          --embla-slide-number: calc(100% / 2);\n          --embla-slide-gap: 1rem;\n          margin-bottom: -2rem;\n\n          .embla__viewport {\n            padding: 2rem 0;\n\n            .embla__container {\n              .embla__slide {\n                padding: 0 0.25rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .slot-games-wrap {\n      .slot-games-box {\n        .games-grid-box {\n          --grid-column-number: 2;\n        }\n\n        .embla {\n          --embla-slide-number: calc(100% / 2);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
